import Link from "next/link";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { DOC_PAGES, docPath } from "@/lib/docs/content";
import { OPENAPI_PATH } from "@/lib/docs/api";

const EYEBROW = "text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]";

const SidebarLinks = ({ current }: { current: string }) => {
  const guides = DOC_PAGES.filter((page) => page.kind === "guide");
  const groups = DOC_PAGES.filter((page) => page.kind === "group");

  const item = (href: string, label: string, active: boolean) => (
    <li key={href}>
      <Link
        href={href}
        prefetch={false}
        className={cn(
          "block rounded-md px-2.5 py-1.5 text-[13.5px] transition-colors hover:bg-[#F9FBFF] hover:text-[#335CFF]",
          active ? "bg-[#EEF3FF] font-medium text-[#335CFF]" : "text-[#525866]",
        )}
      >
        {label}
      </Link>
    </li>
  );

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1.5">
        <span className={cn(EYEBROW, "px-2.5")}>Overview</span>
        <ul className="flex flex-col gap-0.5">
          {item(docPath(""), "API documentation", current === "")}
          {guides.map((page) => item(docPath(page.slug), page.title, current === page.slug))}
        </ul>
      </div>
      <div className="flex flex-col gap-1.5">
        <span className={cn(EYEBROW, "px-2.5")}>Endpoints</span>
        <ul className="flex flex-col gap-0.5">
          {groups.map((page) => item(docPath(page.slug), page.title, current === page.slug))}
        </ul>
      </div>
      <div className="flex flex-col gap-1.5">
        <span className={cn(EYEBROW, "px-2.5")}>Download</span>
        <ul className="flex flex-col gap-0.5">
          <li>
            <a
              href={OPENAPI_PATH}
              className="block rounded-md px-2.5 py-1.5 font-mono text-[12.5px] text-[#525866] transition-colors hover:bg-[#F9FBFF] hover:text-[#335CFF]"
            >
              openapi.json
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

const DocsSidebar = ({ current }: { current: string }) => (
  <>
    <aside className="hidden w-[240px] shrink-0 lg:block">
      <nav aria-label="API docs" className="sticky top-24">
        <SidebarLinks current={current} />
      </nav>
    </aside>
    <details className="group rounded-xl border border-[#EFF2FF] bg-white lg:hidden">
      <summary className="flex cursor-pointer list-none items-center justify-between px-4 py-3 text-[13.5px] font-medium text-[#101828]">
        Browse the API docs
        <ChevronDown
          className="size-4 text-[#8B93A7] transition-transform group-open:rotate-180"
          strokeWidth={2.5}
          aria-hidden
        />
      </summary>
      <nav aria-label="API docs" className="border-t border-[#EFF2FF] px-2 py-3">
        <SidebarLinks current={current} />
      </nav>
    </details>
  </>
);

export default DocsSidebar;
